import React, { useEffect } from 'react'
import { Form, Field, FormikProps } from 'formik'
import { DialogActions, CircularProgress } from '@material-ui/core'
import {
  StyledModalContent,
  StyledThumbnail,
  FlexibleWrapper,
} from '../UploadModal/styled'
import Button from '../StyledButton'
import { CustomTextField } from '../CustomTextField'
import { LinearDeterminate } from '../LinearDeterminate'

export interface IDataChartModalForm {
  formikProps: FormikProps<{ fileName: string }>
  showThumbnail: boolean
  fileTemporaryURL: string
  handleClose: () => void
  isLoading?: boolean
}

export const DataChartModalForm = ({
  formikProps: { validateForm, errors },
  showThumbnail,
  fileTemporaryURL,
  isLoading,
  handleClose,
}: IDataChartModalForm) => {
  useEffect(() => {
    validateForm()
  }, [validateForm])
  return (
    <Form>
      <StyledModalContent>
        {showThumbnail && (
          <StyledThumbnail src={fileTemporaryURL}>
            {!!fileTemporaryURL ? null : <CircularProgress />}
          </StyledThumbnail>
        )}
        <FlexibleWrapper>
          <Field name="fileName" component={CustomTextField} />
        </FlexibleWrapper>
      </StyledModalContent>
      {isLoading ? (
        <LinearDeterminate color="primary" />
      ) : (
        <DialogActions>
          <Button
            id="cancel-button"
            type="button"
            className="cancel-button"
            onClick={handleClose}
            size="small"
            autoFocus
          >
            Cancel
          </Button>
          <Button
            id="action-button"
            type="submit"
            color="primary"
            className="action-button"
            size="small"
            variant="contained"
            disabled={!!errors.fileName}
          >
            Upload
          </Button>
        </DialogActions>
      )}
    </Form>
  )
}
